import { MPR_CAMERA_VALUES } from '../../../constants';
import { OrientationAxis } from '../../../enums';
import getAcquisitionPlaneOrientation from '../../../utilities/getAcquisitionPlaneOrientation';
import { isPlanarOrientationVectors } from './planarLegacyCompatibility';
export function getAcquisitionCameraVectors(imageVolume) {
    const { viewPlaneNormal, viewUp } = getAcquisitionPlaneOrientation(imageVolume);
    return {
        viewPlaneNormal,
        viewUp: viewUp,
    };
}
export function getPlanarViewStateVectors(args) {
    const { imageVolume, orientation } = args;
    if (!orientation) {
        return;
    }
    if (orientation === OrientationAxis.ACQUISITION) {
        return getAcquisitionCameraVectors(imageVolume);
    }
    if (isPlanarOrientationVectors(orientation)) {
        return {
            viewPlaneNormal: [...orientation.viewPlaneNormal],
            viewUp: [
                ...(orientation.viewUp ||
                    getAcquisitionCameraVectors(imageVolume).viewUp),
            ],
        };
    }
    const cameraValues = MPR_CAMERA_VALUES[orientation];
    if (!cameraValues) {
        return;
    }
    return {
        viewPlaneNormal: [...cameraValues.viewPlaneNormal],
        viewUp: [...cameraValues.viewUp],
    };
}
